import { Modal, Box, Button, Typography } from "@mui/material";
import React from "react";
import { primary } from "style/color";

interface InvestmentDetailsModalProps {
  isOpen: boolean;
  onClose: (value: boolean) => void;
  ticker: string;
  name: string;
  description: string | undefined;
}

const InvestmentDetailsModal: React.FC<InvestmentDetailsModalProps> = ({
  isOpen,
  onClose,
  ticker,
  name,
  description,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={() => onClose(false)}
      aria-labelledby="investment-description-title"
      aria-describedby="investment-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          minWidth: 300,
        }}
      >
        <Box sx={{ position: "absolute", top: 8, right: 8 }}>
          <Button
            onClick={() => onClose(false)}
            sx={{ minWidth: 0, padding: 0 }}
            aria-label="Close"
          >
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </Button>
        </Box>

        <Typography
          id="investment-description-title"
          variant="h6"
          mb={2}
          color={primary[600]}
        >
          <b>
            {name} ({ticker})
          </b>
        </Typography>
        <Typography id="investment-description" variant="body1">
          {description || "No description available."}
        </Typography>
      </Box>
    </Modal>
  );
};

export default InvestmentDetailsModal;
